import styles from './GeoSuggestModalContent.css';

export const GeoSuggestModalContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['content']}>{children}</div>;
};
